import { render, staticRenderFns } from "./PrestacaoDeContas.vue?vue&type=template&id=07e2d29e&scoped=true&"
import script from "./PrestacaoDeContas.vue?vue&type=script&lang=js&"
export * from "./PrestacaoDeContas.vue?vue&type=script&lang=js&"
import style0 from "./PrestacaoDeContas.vue?vue&type=style&index=0&id=07e2d29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2d29e",
  null
  
)

export default component.exports